/* import __COLOCATED_TEMPLATE__ from './documents-table.hbs'; */
import { classNames } from '@ember-decorators/component';
import { humanDateFormat } from 'client-portal/utils/date-time';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import stylesSuper from './document-requests-table.module.scss';

@classic
@classNames(stylesSuper.component)
export default class SiteDocumentsTable extends Component {
  @service media;
  humanDateFormat = humanDateFormat;
}
